import { default as NextLink } from 'next/link';
import { FC } from 'react';
import { FontSize, FontWeight, GeneralColors, Radius, Spacing } from '../../../theme';
import { ButtonA } from './style';

interface ButtonLinkProps {
  children: React.ReactNode;
  href: string;
  weight?: FontWeight;
  size?: FontSize;
  fullWidth?: boolean;
  center?: boolean;
  color?: GeneralColors;
  radius?: Radius;
  active?: boolean;
  hasHover?: boolean;
  background?: GeneralColors;
  backgroundHover?: GeneralColors;
  border?: string;
  padding?: Spacing;
  nopadding?: boolean;
  onClick?: () => void;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

const ButtonLink: FC<ButtonLinkProps> = ({
  href,
  children,
  weight,
  size,
  fullWidth,
  center,
  color,
  radius,
  active,
  hasHover,
  background,
  border,
  backgroundHover,
  onClick,
  padding,
  nopadding = false,
  target = '_self',
}) => {
  return (
    <NextLink href={href} passHref>
      <ButtonA
        weight={weight}
        size={size}
        fullWidth={fullWidth}
        center={center}
        color={color}
        radius={radius}
        active={active}
        aria-current={active ? 'page' : undefined}
        hasHover={hasHover}
        background={background}
        border={border}
        backgroundHover={backgroundHover}
        onClick={onClick}
        padding={padding}
        nopadding={nopadding}
        target={target}
      >
        {children}
      </ButtonA>
    </NextLink>
  );
};

export default ButtonLink;
